/*
 * Copyright (c) 2019. Nedaware SL
 */

import {FilterInterface, InvalidFilterProperty, InvalidFilterValue} from "../../api/filter-interface";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * The numeric filter allows to filter numbers. It will accept
 * properties and values which, after the casting process,
 * result in numeric values. Notice Decimals are not numeric,
 * but strings, because of precision.
 */
export class NumericFilter implements FilterInterface {
    dataToParams(property: InternalPropertyMap | null, data: any[] | any): { [p: string]: string | string[] } {
        if (property == null) {
            throw new InvalidFilterProperty(property, "the property cannot be null");
        }
        if (Array.isArray(data)) {
            throw new InvalidFilterValue(data, "numeric filter accepts, exclusively, one value");
        }

        if (property.caster) {
            data = property.caster.fromModel(data);
        }

        if (typeof data !== "number") {
            throw new InvalidFilterValue(data, "data was expected to be casted into a number");
        }

        return {[property.paramName]: data.toString(10)};
    }
}
